import React, { Fragment } from 'react';
import {
  CTAButton3Wrapper,
  CTAButton3HeadlineWrapper,
  CTAButton3OwnUpLogoWrapper,
  CTAButton3HeadlineText,
  CTAButton3LinkWrapper,
  CTAButton3Link
} from './components';
import { OwnUpFillButtonPrimary } from '@rategravity/own-up-component-library';
import { OwnUpWhiteLogo } from '../../../images/icons/ownup-white-logo';

const www = `https://${process.env.GATSBY_WWW}`;

const CTAButtons3 = () => (
  <Fragment>
    <CTAButton3Wrapper>
      <CTAButton3OwnUpLogoWrapper>
        <OwnUpWhiteLogo />
      </CTAButton3OwnUpLogoWrapper>
      <CTAButton3HeadlineWrapper>
        <CTAButton3HeadlineText variant="h3">See What You Qualify For</CTAButton3HeadlineText>
      </CTAButton3HeadlineWrapper>
      <CTAButton3LinkWrapper>
        <CTAButton3Link id="get_started_blogfloat" href={`${www}/onboarding/get-started/`}>
          <OwnUpFillButtonPrimary fullWidth>Get Started</OwnUpFillButtonPrimary>
        </CTAButton3Link>
      </CTAButton3LinkWrapper>
    </CTAButton3Wrapper>
  </Fragment>
);

export default CTAButtons3;
